import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../index";
import axios from "axios";
import { getAuthToken } from "../../utils/utils";

// Async thunk to fetch programs
export const fetchPrograms = createAsyncThunk(
  "programs/fetchPrograms",
  async (userId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.get(baseUrl + "/programs", {
        params: { userId },

        headers: {
          Authorization: `${token}`, // Pass the token here
          "Content-Type": "application/json", // Make sure the content type is correct
        },
        // Send userId to get user-specific data
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Async thunk to create a program
export const createProgram = createAsyncThunk(
  "programs/createProgram",
  async (programData, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(baseUrl + "/programs", programData, {
        headers: {
          Authorization: `${token}`, // Pass the token here
          "Content-Type": "application/json", // Make sure the content type is correct
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateProgram = createAsyncThunk(
  "programs/updateProgram",
  async (programData, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.put(
        baseUrl + "/programs/details",
        programData,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateProgramYear = createAsyncThunk(
  "programs/updateProgramYear",
  async (programYearData, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.put(
        baseUrl + "/programs/years",
        programYearData,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const addProgramYear = createAsyncThunk(
  "programs/addProgramYear",
  async (programId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(
        baseUrl + "/programs/addyear",
        programId,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteProgram = createAsyncThunk(
  "programs/deleteProgram",
  async (programId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.delete(baseUrl + "/programs", {
        params: { id: programId }, // Send userId to get user-specific data

        headers: {
          Authorization: `${token}`, // Pass the token here
          "Content-Type": "application/json", // Make sure the content type is correct
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const programSlice = createSlice({
  name: "programs",
  initialState: {
    programs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrograms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrograms.fulfilled, (state, action) => {
        state.loading = false;
        state.programs = action.payload;
      })
      .addCase(fetchPrograms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createProgram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.programs.push(action.payload);
      })
      .addCase(createProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addProgramYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProgramYear.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addProgramYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateProgram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProgram.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateProgramYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProgramYear.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProgramYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteProgram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProgram.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default programSlice.reducer;
